var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 8.60001C17.2698 8.60001 18.2998 7.57 18.2998 6.3C18.2998 5.03 17.2698 4.00001 15.9998 4.00001C14.7298 4.00001 13.6998 5.03001 13.6998 6.30001C13.6998 7.57001 14.7298 8.60001 15.9998 8.60001Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 23.4C14.7298 23.4 13.6998 24.43 13.6998 25.7C13.6998 26.97 14.7298 28 15.9998 28C17.2698 28 18.2998 26.97 18.2998 25.7C18.2998 24.43 17.2698 23.4 15.9998 23.4Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 18.3C17.2698 18.3 18.2998 17.27 18.2998 16C18.2998 14.73 17.2698 13.7 15.9998 13.7C14.7298 13.7 13.6998 14.73 13.6998 16C13.6998 17.27 14.7298 18.3 15.9998 18.3Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDotIcon);
export default __webpack_public_path__ + "static/media/moreDotIcon.9e5b8416fbbb85ab1379185d71e42231.svg";
export { ForwardRef as ReactComponent };